import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import PublicNavHeader from '../components/PublicNavHeader';
import Footer from '../components/Footer';

import {
  ArrowRight,
  Briefcase
} from '@phosphor-icons/react';
const Careers = () => {
  return (
    <>
      <SEO title="Careers - Man & Machine" description="Join our team and help build the future of Business AI." />
      <PublicNavHeader />
      
      <div className="min-h-screen bg-[#0a0a0f]">
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#6366F1]/10 via-transparent to-[#EC4899]/10" />
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#6366F1]/20 blur-[120px] rounded-full" />
          
          <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center max-w-3xl mx-auto"
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#6366F1]/10 border border-[#6366F1]/20 text-[#6366F1] text-sm font-medium mb-6">
                <Briefcase size={16} />
                Careers
              </div>
              
              <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                Build the Future of{' '}
                <span className="bg-gradient-to-r from-[#6366F1] to-[#EC4899] text-transparent bg-clip-text">
                  Business AI
                </span>
              </h1>
              
              <p className="text-lg text-[#A0AEC0]">
                Join a team passionate about making AI accessible to every business.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-6 pb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="glass rounded-2xl p-8 text-center"
          >
            <div className="w-16 h-16 rounded-full bg-[#6366F1]/10 flex items-center justify-center mx-auto mb-4">
              <Briefcase size={32} className="text-[#6366F1]" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-3">No Open Positions</h2>
            <p className="text-[#A0AEC0] mb-6 max-w-md mx-auto">
              We don't have any open positions right now, but we're always looking for talented people. Send us your resume and we'll keep you in mind.
            </p>
            <a
              href="mailto:enquiries@manandmachine.app"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white font-semibold rounded-full hover:opacity-90 transition-opacity"
            >
              Send Your Resume
              <ArrowRight size={18} />
            </a>
          </motion.div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default Careers;